import isAppInstall from '../isAppInstall';
import appInfoMap from '../isAppInstall/appInfoMap';
export default (appName) => {
    const appInfo = appInfoMap[appName];
    if (!appInfo) {
        return Promise.resolve(false);
    }
    return isAppInstall(appInfo.schema, appInfo.pkgName);
};
